/**
 * @desc 获取信用卡分期银行卡列表信息
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** @Min: 1.0 - @Max: null (until #1244 gets fixed) */
  detail: number
  /** orderNo */
  orderNo: string
  /** @Min: 1.0 - @Max: null (until #1244 gets fixed) */
  paymentPlatformType: number
  /** sign */
  sign: string
  /** token */
  token: string
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/merchant/creditBankList',
    params,
    method: 'get',
  })
}
